import React, { useEffect, useState } from "react";
import { Col, Row, Skeleton } from "antd";
import { StyledCard } from "./style";

const CustomerView = ({ allBlockScriptData, allBlockScriptLoading }) => {
  const [marketData, setMarketData] = useState({});

  useEffect(() => {
    if (allBlockScriptData?.length > 0) {
      const updatedData = allBlockScriptData?.reduce((acc, curr) => {
        if (!acc?.[curr?.marketName]) {
          acc[curr.marketName] = [{ curr }];
        } else {
          acc[curr?.marketName].push(curr);
        }
        return acc;
      }, {});
      setMarketData(updatedData);
    }
  }, [allBlockScriptData]);

  return (
    <div>
      {allBlockScriptLoading ? (
        <StyledCard>
          <Skeleton />
        </StyledCard>
      ) : (
        Object.keys(marketData)?.map((marketName) => {
          return (
            <StyledCard
              title={<p>{marketName}</p>}
              style={{ marginBottom: "0.5rem" }}
            >
              {marketData[marketName]?.map((data) => {
                return (
                  <Row justify={"space-between"}>
                    <Col style={{ color: "green" }}>{data?.Script}</Col>
                    <Col style={{ color: "red" }}>{data?.blockedBy}</Col>
                  </Row>
                );
              })}
            </StyledCard>
          );
        })
      )}
      {/* {Object.keys(marketData)?.map((marketName) => {
        return (
          <StyledCard
            title={<p>{marketName}</p>}
            style={{ marginBottom: "0.5rem" }}
          >
            {marketData[marketName]?.map((data) => {
              return (
                <Row justify={"space-between"}>
                  <Col style={{ color: "green" }}>{data?.Script}</Col>
                  <Col style={{ color: "red" }}>{data?.blockedBy}</Col>
                </Row>
              );
            })}
          </StyledCard>
        );
      })} */}
    </div>
  );
};

export default React.memo(CustomerView);
